import axios from 'axios';
import * as StackTrace from 'stacktrace-js';

window.lastErrorMessage = window.lastErrorMessage || '';

function logError(errorForm, error) {
  axios
    .post(`${window.sm.url}/logging/errors`, errorForm)
    .catch(serverError => console.error('Something went wrong while pushing an error to the server.', serverError, error));
}

export default function handleError(error) {
  if (window.location.hostname === 'localhost') {
    throw error;
  }

  if (window.lastErrorMessage === error.message) {
    throw error;
  }

  window.lastErrorMessage = error.message;

  const browser = navigator ? navigator.userAgent : 'Unknown';

  const errorForm = {
    message: `Customer Portal error, Browser ${browser}, Error: ${error.message}`,
    url: window.location.href,
    stackTrace: '',
  };

  if (error.stack) {
    errorForm.stackTrace = error.stack;
    logError(errorForm, error);
  } else {
    StackTrace.fromError(error).then((frames) => {
      errorForm.stackTrace = frames
        .splice(0, 10)
        .map(sf => sf.toString()).join('\n');
      logError(errorForm, error);
    });
  }

  throw error;
}
